import { Box, Container, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#202B36", // matches screenshot background
        color: "#FFFFFF",
        pt: { xs: 2, md: 6 },
        pb: { xs: 2, md: 4 }
      }}
    >
      <Container maxWidth={false} sx={{ px: { xs: 2, md: 6 } }}>
        <Box
          sx={{
            mt: { xs: 6, md: 10 },
            pt: { xs: 3, md: 4 },
            borderTop: "1px solid #445160", // subtle divider line color from screenshot
          }}
        >
          <Typography
            align="center"
            sx={{
              fontSize: { xs: 13, md: 16 },
              letterSpacing: 0.2,
              color: "#FFFFFF",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              fontSize: "14px",
              fontWeight: "600"
            }}
          >
            <Box component="span">
              © {new Date().getFullYear()} AlphaForce Technology Solutions, Inc-
              Project &amp; Staffing Solutions.
            </Box>
            <Box
              component="a"
              href="/terms-of-use"
              sx={{
                ml: { xs: 0, md: 1 },
                color: "rgba(255,255,255,0.7)",
                textDecoration: "none",
                fontWeight: 500,
                "&:hover": {
                  color: "#FFFFFF",
                },
              }}
            >
              Terms of Use
            </Box>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
